import { render, staticRenderFns } from "./ReportContractWillExpired.vue?vue&type=template&id=65fabe52&scoped=true"
import script from "./ReportContractWillExpired.vue?vue&type=script&lang=js"
export * from "./ReportContractWillExpired.vue?vue&type=script&lang=js"
import style0 from "./ReportContractWillExpired.vue?vue&type=style&index=0&id=65fabe52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fabe52",
  null
  
)

export default component.exports